/* src/app/common/components/lumi/lumi-chat-message/lumi-chat-message.component.scss */
:host {
  display: block;
  opacity: 0;
  animation: chatFadeInUp 200ms ease-out forwards;
  animation-delay: var(--anim-delay, 0ms);
}
:host(.lumi-chat-message-host--user) {
  margin-bottom: 0.375rem;
}
:host(.lumi-chat-message-host--bot) {
  margin-bottom: 1.25rem;
}
@keyframes chatFadeInUp {
  from {
    opacity: 0;
    transform: translateY(0.5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes wordFadeIn {
  from {
    opacity: 0;
    filter: blur(2px);
    transform: translateX(-4px);
  }
  to {
    opacity: 1;
    filter: blur(0);
    transform: translateX(0);
  }
}
@keyframes chatFadeOutDown {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(0.5rem);
  }
}
.lumi-chat-message {
  position: relative;
  display: grid;
  grid-template-columns: 25px calc(100% - 50px - 1rem);
  justify-content: center;
  align-items: flex-end;
  gap: 0.5rem;
}
.lumi-chat-message--user {
  grid-template-columns: calc(100% - 50px - 1rem) 25px;
}
.lumi-chat-message--user .lumi-chat-bubble {
  justify-self: end;
}
.lumi-chat-message .lumi-chat-message-footer {
  grid-column: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.lumi-chat-message .lumi-chat-message-footer .lumi-chat-timestamp {
  margin-right: 2rem;
}
.lumi-chat-message .lumi-chat-message-footer--timestamp-only {
  justify-content: flex-end;
}
.lumi-chat-message .lumi-chat-message-footer--timestamp-only .lumi-chat-timestamp {
  margin-top: -0.25rem;
  margin-right: 2rem;
}
.lumi-chat-message .lumi-chat-feedback-hint-wrapper {
  grid-column: 2;
  display: flex;
  align-items: flex-start;
  gap: 0.25rem;
  padding-top: 0;
  padding-left: 0.25rem;
  margin-top: -10px;
  min-height: 0;
}
.lumi-chat-message .lumi-chat-feedback-hint-wrapper .lumi-chat-feedback-arrow {
  opacity: 0.25;
}
.lumi-chat-avatar {
  flex-shrink: 0;
  width: 1.45rem;
  height: 1.45rem;
}
.lumi-chat-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
.lumi-chat-bubble {
  overflow: hidden;
  border-radius: 0.75rem;
  padding: 0.75rem;
  font-family: "PoppinsRegular";
  font-size: 0.75rem;
  line-height: 1.25rem;
  width: calc(100% - 33.5px - 1rem - 0.5rem);
}
.lumi-chat-bubble--bot {
  background-color: #1E31BF;
  color: #FFFFFF;
  border-bottom-left-radius: 0.125rem;
  transition:
    max-width 0.45s cubic-bezier(0.4, 0, 0.2, 1),
    width 0.45s cubic-bezier(0.4, 0, 0.2, 1),
    padding 0.35s ease;
}
.lumi-chat-bubble--bot strong {
  font-family: "PoppinsBold";
}
.lumi-chat-bubble--bot p {
  margin: 0;
}
.lumi-chat-bubble--bot ::ng-deep .lumi-word-fade {
  display: inline;
  opacity: 0;
  animation: wordFadeIn 350ms ease-out forwards;
}
.lumi-chat-bubble--bot.lumi-chat-bubble--pending {
  width: fit-content;
  max-width: 3.75rem;
  justify-self: start;
  padding: 0.625rem 0.875rem;
}
.lumi-chat-bubble--user {
  background-color: #EBEBEB;
  color: #000000;
  border: none;
  border-bottom-right-radius: 0.125rem;
}
.lumi-chat-bot-stream {
  display: inline;
  line-height: inherit;
}
.lumi-chat-bot-content {
  display: inline;
}
.lumi-typing-indicator {
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 1.25rem;
  animation: lumiTypingBulge 2s infinite ease-out;
}
.lumi-typing-indicator > span {
  height: 0.5rem;
  width: 0.5rem;
  margin: 0 0.0625rem;
  background-color: rgba(255, 255, 255, 0.55);
  display: block;
  border-radius: 50%;
  opacity: 0.45;
}
.lumi-typing-indicator > span:nth-of-type(1) {
  animation: lumiTypingBlink 1s infinite 0.3333s;
}
.lumi-typing-indicator > span:nth-of-type(2) {
  animation: lumiTypingBlink 1s infinite 0.6666s;
}
.lumi-typing-indicator > span:nth-of-type(3) {
  animation: lumiTypingBlink 1s infinite 0.9999s;
}
.lumi-typing-indicator--inline {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  vertical-align: middle;
  height: 1em;
  margin-left: 0.35em;
  margin-right: 0.05em;
  transform-origin: left center;
  animation: lumiInlineTypingIntro 300ms ease-out both;
}
.lumi-typing-indicator--inline > span {
  height: 0.22rem;
  width: 0.22rem;
  margin: 0 0.05rem;
  opacity: 0.5;
}
@media (prefers-reduced-motion: reduce) {
  .lumi-typing-indicator--inline {
    animation: none;
    opacity: 1;
    transform: scale(0.62);
  }
}
@keyframes lumiInlineTypingIntro {
  from {
    opacity: 0;
    transform: scale(0.28);
  }
  to {
    opacity: 1;
    transform: scale(0.62);
  }
}
@keyframes lumiTypingBlink {
  50% {
    opacity: 1;
  }
}
@keyframes lumiTypingBulge {
  50% {
    transform: scale(1.05);
  }
}
.lumi-chat-sources {
  margin-top: 0.75rem;
}
.lumi-chat-sources .lumi-chat-sources-label {
  display: block;
  font-family: "Verveine";
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 0.375rem;
}
.lumi-chat-sources .lumi-chat-source-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.375rem;
  background-color: rgba(0, 0, 0, 0.2);
  border: none;
  border-radius: 0.375rem;
  padding: 0.125rem 0.375rem 0.25rem;
  margin-bottom: 0.375rem;
  text-decoration: none;
  color: #FFFFFF;
  font-family: "PoppinsRegular";
  font-size: 0.75rem;
  transition: background-color 300ms ease-in-out;
}
.lumi-chat-sources .lumi-chat-source-link:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
.lumi-chat-sources .lumi-chat-source-link .lumi-chat-source-chevron {
  display: flex;
  flex-shrink: 0;
  transform: translateX(0);
  transition: transform 300ms ease-out;
}
.lumi-chat-sources .lumi-chat-source-link .lumi-chat-source-chevron ::ng-deep svg-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
}
.lumi-chat-sources .lumi-chat-source-link .lumi-chat-source-chevron ::ng-deep svg-icon svg path {
  fill: #FFFFFF !important;
}
.lumi-chat-sources .lumi-chat-source-link:hover .lumi-chat-source-chevron {
  transform: translateX(0.125rem);
}
.lumi-chat-sources--project .lumi-chat-sources-label {
  color: rgba(255, 255, 255, 0.88);
}
.lumi-chat-sources--project .lumi-chat-source-link {
  width: 100%;
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0.32);
}
.lumi-chat-sources--project .lumi-chat-source-link:hover {
  background-color: rgba(0, 0, 0, 0.44);
}
.lumi-chat-timestamp {
  text-align: right;
  font-family: "PoppinsRegular";
  font-size: 0.625rem;
  color: #757575;
}
.lumi-chat-feedback {
  display: flex;
  gap: 0.125rem;
}
.lumi-chat-feedback .lumi-chat-feedback-btn {
  background: none;
  border: none;
  padding: 0.125rem;
  cursor: pointer;
}
.lumi-chat-feedback .lumi-chat-feedback-btn ::ng-deep svg-icon svg {
  height: 1.25rem !important;
  width: 1.25rem !important;
}
.lumi-chat-feedback .lumi-chat-feedback-btn {
  opacity: 0.6;
  transition: opacity 300ms ease-in-out;
}
.lumi-chat-feedback .lumi-chat-feedback-btn:hover {
  opacity: 1;
}
.lumi-chat-feedback .lumi-chat-feedback-btn--down {
  transform: rotate(180deg);
}
.lumi-chat-feedback .lumi-chat-feedback-btn--active-up {
  opacity: 1;
  animation: feedbackFlash 600ms ease-out;
}
.lumi-chat-feedback .lumi-chat-feedback-btn--active-up ::ng-deep svg path {
  stroke: #108467;
  animation: feedbackStrokeSuccess 600ms ease-out;
}
.lumi-chat-feedback .lumi-chat-feedback-btn--active-down {
  opacity: 1;
  animation: feedbackFlashDown 600ms ease-out;
}
.lumi-chat-feedback .lumi-chat-feedback-btn--active-down ::ng-deep svg path {
  stroke: #DB2121;
  animation: feedbackStrokeDanger 600ms ease-out;
}
@keyframes feedbackFlash {
  0% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes feedbackFlashDown {
  0% {
    transform: scale(1) rotate(180deg);
  }
  30% {
    transform: scale(1.25) rotate(180deg);
  }
  100% {
    transform: scale(1) rotate(180deg);
  }
}
@keyframes feedbackStrokeSuccess {
  0% {
    stroke: #9CA3AF;
  }
  30% {
    stroke: #108467;
  }
  100% {
    stroke: #108467;
  }
}
@keyframes feedbackStrokeDanger {
  0% {
    stroke: #9CA3AF;
  }
  30% {
    stroke: #DB2121;
  }
  100% {
    stroke: #DB2121;
  }
}
.lumi-chat-feedback-arrow {
  width: 2.5rem;
  height: auto;
  flex-shrink: 0;
}
.lumi-chat-feedback-hint {
  display: block;
  font-family: "Verveine";
  font-size: 1rem;
  line-height: 1.25rem;
  color: rgba(30, 49, 191, 0.24);
  max-width: 250px;
  padding-top: 15px;
  margin: 0;
}
.lumi-chat-feedback-thankyou {
  width: calc(100% - 33.5px);
  grid-column: 2;
  text-align: center;
  animation: chatFadeInUp 200ms ease-out forwards;
  padding: 0.5rem 0;
  position: relative;
}
.lumi-chat-feedback-thankyou.fading-out {
  animation: chatFadeOutDown 200ms ease-in forwards;
}
.lumi-chat-feedback-thankyou .lumi-chat-feedback-thankyou-dismiss {
  position: absolute;
  top: 0.5rem;
  right: 0;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}
.lumi-chat-feedback-thankyou .lumi-chat-feedback-thankyou-dismiss ::ng-deep svg-icon svg {
  height: 0.875rem !important;
  width: 0.875rem !important;
}
.lumi-chat-feedback-thankyou .lumi-chat-feedback-thankyou-dismiss {
  opacity: 0.5;
  transition: opacity 200ms ease-in-out;
}
.lumi-chat-feedback-thankyou .lumi-chat-feedback-thankyou-dismiss:hover {
  opacity: 1;
}
.lumi-chat-feedback-thankyou .lumi-chat-feedback-thankyou-emoji {
  font-size: 1.5rem;
  margin-bottom: 0.25rem;
}
.lumi-chat-feedback-thankyou .lumi-chat-feedback-thankyou-message {
  font-family: "Verveine";
  font-size: 1.25rem;
  line-height: 1.5rem;
  color: #1E31BF;
  margin: 0 auto;
  max-width: 16rem;
}
.lumi-chat-feedback-thankyou .lumi-chat-feedback-thankyou-note {
  font-family: "PoppinsRegular";
  font-size: 0.6rem;
  line-height: 0.75rem;
  color: #AAAAAA;
  margin-top: 0.5rem;
}
/*# sourceMappingURL=lumi-chat-message.component.css.map */
